const mimeTypeObj: Record<string, {extensions: string[]}> = {
  'application/andrew-inset': {
    extensions: ['ez'],
  },
  'application/appinstaller': {
    extensions: ['appinstaller'],
  },
  'application/applixware': {
    extensions: ['aw'],
  },
  'application/appx': {
    extensions: ['appx'],
  },
  'application/appxbundle': {
    extensions: ['appxbundle'],
  },
  'application/atom+xml': {
    extensions: ['atom'],
  },
  'application/atomcat+xml': {
    extensions: ['atomcat'],
  },
  'application/atomdeleted+xml': {
    extensions: ['atomdeleted'],
  },
  'application/atomsvc+xml': {
    extensions: ['atomsvc'],
  },
  'application/atsc-dwd+xml': {
    extensions: ['dwd'],
  },
  'application/atsc-held+xml': {
    extensions: ['held'],
  },
  'application/atsc-rsat+xml': {
    extensions: ['rsat'],
  },
  'application/automationml-aml+xml': {
    extensions: ['aml'],
  },
  'application/automationml-amlx+zip': {
    extensions: ['amlx'],
  },
  'application/bdoc': {
    extensions: ['bdoc'],
  },
  'application/calendar+xml': {
    extensions: ['xcs'],
  },
  'application/ccxml+xml': {
    extensions: ['ccxml'],
  },
  'application/cdfx+xml': {
    extensions: ['cdfx'],
  },
  'application/cdmi-capability': {
    extensions: ['cdmia'],
  },
  'application/cdmi-container': {
    extensions: ['cdmic'],
  },
  'application/cdmi-domain': {
    extensions: ['cdmid'],
  },
  'application/cdmi-object': {
    extensions: ['cdmio'],
  },
  'application/cdmi-queue': {
    extensions: ['cdmiq'],
  },
  'application/cpl+xml': {
    extensions: ['cpl'],
  },
  'application/cu-seeme': {
    extensions: ['cu'],
  },
  'application/cwl': {
    extensions: ['cwl'],
  },
  'application/dash+xml': {
    extensions: ['mpd'],
  },
  'application/dash-patch+xml': {
    extensions: ['mpp'],
  },
  'application/davmount+xml': {
    extensions: ['davmount'],
  },
  'application/dicom': {
    extensions: ['dcm'],
  },
  'application/docbook+xml': {
    extensions: ['dbk'],
  },
  'application/dssc+der': {
    extensions: ['dssc'],
  },
  'application/dssc+xml': {
    extensions: ['xdssc'],
  },
  'application/ecmascript': {
    extensions: ['ecma'],
  },
  'application/emma+xml': {
    extensions: ['emma'],
  },
  'application/emotionml+xml': {
    extensions: ['emotionml'],
  },
  'application/epub+zip': {
    extensions: ['epub'],
  },
  'application/exi': {
    extensions: ['exi'],
  },
  'application/express': {
    extensions: ['exp'],
  },
  'application/fdf': {
    extensions: ['fdf'],
  },
  'application/fdt+xml': {
    extensions: ['fdt'],
  },
  'application/font-tdpfr': {
    extensions: ['pfr'],
  },
  'application/geo+json': {
    extensions: ['geojson'],
  },
  'application/gml+xml': {
    extensions: ['gml'],
  },
  'application/gpx+xml': {
    extensions: ['gpx'],
  },
  'application/gxf': {
    extensions: ['gxf'],
  },
  'application/gzip': {
    extensions: ['gz'],
  },
  'application/hjson': {
    extensions: ['hjson'],
  },
  'application/hyperstudio': {
    extensions: ['stk'],
  },
  'application/inkml+xml': {
    extensions: ['ink', 'inkml'],
  },
  'application/ipfix': {
    extensions: ['ipfix'],
  },
  'application/its+xml': {
    extensions: ['its'],
  },
  'application/java-archive': {
    extensions: ['jar', 'war', 'ear'],
  },
  'application/java-serialized-object': {
    extensions: ['ser'],
  },
  'application/java-vm': {
    extensions: ['class'],
  },
  'application/javascript': {
    extensions: ['js'],
  },
  'application/json': {
    extensions: ['json', 'map'],
  },
  'application/json5': {
    extensions: ['json5'],
  },
  'application/jsonml+json': {
    extensions: ['jsonml'],
  },
  'application/kbl+xml': {
    extensions: ['kbl'],
  },
  'application/ld+json': {
    extensions: ['jsonld'],
  },
  'application/lgr+xml': {
    extensions: ['lgr'],
  },
  'application/lost+xml': {
    extensions: ['lostxml'],
  },
  'application/mac-binhex40': {
    extensions: ['hqx'],
  },
  'application/mac-compactpro': {
    extensions: ['cpt'],
  },
  'application/mads+xml': {
    extensions: ['mads'],
  },
  'application/manifest+json': {
    extensions: ['webmanifest'],
  },
  'application/marc': {
    extensions: ['mrc'],
  },
  'application/marcxml+xml': {
    extensions: ['mrcx'],
  },
  'application/mathematica': {
    extensions: ['ma', 'nb', 'mb'],
  },
  'application/mathml+xml': {
    extensions: ['mathml'],
  },
  'application/mbox': {
    extensions: ['mbox'],
  },
  'application/media-policy-dataset+xml': {
    extensions: ['mpf'],
  },
  'application/mediaservercontrol+xml': {
    extensions: ['mscml'],
  },
  'application/metalink+xml': {
    extensions: ['metalink'],
  },
  'application/metalink4+xml': {
    extensions: ['meta4'],
  },
  'application/mets+xml': {
    extensions: ['mets'],
  },
  'application/mmt-aei+xml': {
    extensions: ['maei'],
  },
  'application/mmt-usd+xml': {
    extensions: ['musd'],
  },
  'application/mods+xml': {
    extensions: ['mods'],
  },
  'application/mp21': {
    extensions: ['m21', 'mp21'],
  },
  'application/mp4': {
    extensions: ['mp4', 'mpg4', 'mp4s', 'm4p'],
  },
  'application/msix': {
    extensions: ['msix'],
  },
  'application/msixbundle': {
    extensions: ['msixbundle'],
  },
  'application/msword': {
    extensions: ['doc', 'dot'],
  },
  'application/mxf': {
    extensions: ['mxf'],
  },
  'application/n-quads': {
    extensions: ['nq'],
  },
  'application/n-triples': {
    extensions: ['nt'],
  },
  'application/node': {
    extensions: ['cjs'],
  },
  'application/octet-stream': {
    extensions: [
      'bin',
      'dms',
      'lrf',
      'mar',
      'so',
      'dist',
      'distz',
      'pkg',
      'bpk',
      'dump',
      'elc',
      'deploy',
      'exe',
      'dll',
      'deb',
      'dmg',
      'iso',
      'img',
      'msi',
      'msp',
      'msm',
      'buffer',
    ],
  },
  'application/oda': {
    extensions: ['oda'],
  },
  'application/oebps-package+xml': {
    extensions: ['opf'],
  },
  'application/ogg': {
    extensions: ['ogx'],
  },
  'application/omdoc+xml': {
    extensions: ['omdoc'],
  },
  'application/onenote': {
    extensions: ['onetoc', 'onetoc2', 'onetmp', 'onepkg', 'one', 'onea'],
  },
  'application/oxps': {
    extensions: ['oxps'],
  },
  'application/p2p-overlay+xml': {
    extensions: ['relo'],
  },
  'application/patch-ops-error+xml': {
    extensions: ['xer'],
  },
  'application/pdf': {
    extensions: ['pdf'],
  },
  'application/pgp-encrypted': {
    extensions: ['pgp'],
  },
  'application/pgp-keys': {
    extensions: ['asc'],
  },
  'application/pgp-signature': {
    extensions: ['sig', 'asc'],
  },
  'application/pics-rules': {
    extensions: ['prf'],
  },
  'application/pkcs10': {
    extensions: ['p10'],
  },
  'application/pkcs7-mime': {
    extensions: ['p7m', 'p7c'],
  },
  'application/pkcs7-signature': {
    extensions: ['p7s'],
  },
  'application/pkcs8': {
    extensions: ['p8'],
  },
  'application/pkix-attr-cert': {
    extensions: ['ac'],
  },
  'application/pkix-cert': {
    extensions: ['cer'],
  },
  'application/pkix-crl': {
    extensions: ['crl'],
  },
  'application/pkix-pkipath': {
    extensions: ['pkipath'],
  },
  'application/pkixcmp': {
    extensions: ['pki'],
  },
  'application/pls+xml': {
    extensions: ['pls'],
  },
  'application/postscript': {
    extensions: ['ai', 'eps', 'ps'],
  },
  'application/provenance+xml': {
    extensions: ['provx'],
  },
  'application/prs.cww': {
    extensions: ['cww'],
  },
  'application/prs.xsf+xml': {
    extensions: ['xsf'],
  },
  'application/pskc+xml': {
    extensions: ['pskcxml'],
  },
  'application/raml+yaml': {
    extensions: ['raml'],
  },
  'application/rdf+xml': {
    extensions: ['rdf', 'owl'],
  },
  'application/reginfo+xml': {
    extensions: ['rif'],
  },
  'application/relax-ng-compact-syntax': {
    extensions: ['rnc'],
  },
  'application/resource-lists+xml': {
    extensions: ['rl'],
  },
  'application/resource-lists-diff+xml': {
    extensions: ['rld'],
  },
  'application/rls-services+xml': {
    extensions: ['rs'],
  },
  'application/route-apd+xml': {
    extensions: ['rapd'],
  },
  'application/route-s-tsid+xml': {
    extensions: ['sls'],
  },
  'application/route-usd+xml': {
    extensions: ['rusd'],
  },
  'application/rpki-ghostbusters': {
    extensions: ['gbr'],
  },
  'application/rpki-manifest': {
    extensions: ['mft'],
  },
  'application/rpki-roa': {
    extensions: ['roa'],
  },
  'application/rsd+xml': {
    extensions: ['rsd'],
  },
  'application/rss+xml': {
    extensions: ['rss'],
  },
  'application/rtf': {
    extensions: ['rtf'],
  },
  'application/sbml+xml': {
    extensions: ['sbml'],
  },
  'application/scvp-cv-request': {
    extensions: ['scq'],
  },
  'application/scvp-cv-response': {
    extensions: ['scs'],
  },
  'application/scvp-vp-request': {
    extensions: ['spq'],
  },
  'application/scvp-vp-response': {
    extensions: ['spp'],
  },
  'application/sdp': {
    extensions: ['sdp'],
  },
  'application/senml+xml': {
    extensions: ['senmlx'],
  },
  'application/sensml+xml': {
    extensions: ['sensmlx'],
  },
  'application/set-payment-initiation': {
    extensions: ['setpay'],
  },
  'application/set-registration-initiation': {
    extensions: ['setreg'],
  },
  'application/shf+xml': {
    extensions: ['shf'],
  },
  'application/sieve': {
    extensions: ['siv', 'sieve'],
  },
  'application/smil+xml': {
    extensions: ['smi', 'smil'],
  },
  'application/sparql-query': {
    extensions: ['rq'],
  },
  'application/sparql-results+xml': {
    extensions: ['srx'],
  },
  'application/sql': {
    extensions: ['sql'],
  },
  'application/srgs': {
    extensions: ['gram'],
  },
  'application/srgs+xml': {
    extensions: ['grxml'],
  },
  'application/sru+xml': {
    extensions: ['sru'],
  },
  'application/ssdl+xml': {
    extensions: ['ssdl'],
  },
  'application/ssml+xml': {
    extensions: ['ssml'],
  },
  'application/swid+xml': {
    extensions: ['swidtag'],
  },
  'application/tei+xml': {
    extensions: ['tei', 'teicorpus'],
  },
  'application/thraud+xml': {
    extensions: ['tfi'],
  },
  'application/timestamped-data': {
    extensions: ['tsd'],
  },
  'application/toml': {
    extensions: ['toml'],
  },
  'application/trig': {
    extensions: ['trig'],
  },
  'application/ttml+xml': {
    extensions: ['ttml'],
  },
  'application/ubjson': {
    extensions: ['ubj'],
  },
  'application/urc-ressheet+xml': {
    extensions: ['rsheet'],
  },
  'application/urc-targetdesc+xml': {
    extensions: ['td'],
  },
  'application/vec+xml': {
    extensions: ['vec'],
  },
  'application/vnd.1000minds.decision-model+xml': {
    extensions: ['1km'],
  },
  'application/vnd.3gpp.pic-bw-large': {
    extensions: ['plb'],
  },
  'application/vnd.3gpp.pic-bw-small': {
    extensions: ['psb'],
  },
  'application/vnd.3gpp.pic-bw-var': {
    extensions: ['pvb'],
  },
  'application/vnd.3gpp2.tcap': {
    extensions: ['tcap'],
  },
  'application/vnd.3m.post-it-notes': {
    extensions: ['pwn'],
  },
  'application/vnd.accpac.simply.aso': {
    extensions: ['aso'],
  },
  'application/vnd.accpac.simply.imp': {
    extensions: ['imp'],
  },
  'application/vnd.acucobol': {
    extensions: ['acu'],
  },
  'application/vnd.acucorp': {
    extensions: ['atc', 'acutc'],
  },
  'application/vnd.adobe.air-application-installer-package+zip': {
    extensions: ['air'],
  },
  'application/vnd.adobe.formscentral.fcdt': {
    extensions: ['fcdt'],
  },
  'application/vnd.adobe.fxp': {
    extensions: ['fxp', 'fxpl'],
  },
  'application/vnd.adobe.xdp+xml': {
    extensions: ['xdp'],
  },
  'application/vnd.adobe.xfdf': {
    extensions: ['xfdf'],
  },
  'application/vnd.age': {
    extensions: ['age'],
  },
  'application/vnd.ahead.space': {
    extensions: ['ahead'],
  },
  'application/vnd.airzip.filesecure.azf': {
    extensions: ['azf'],
  },
  'application/vnd.airzip.filesecure.azs': {
    extensions: ['azs'],
  },
  'application/vnd.amazon.ebook': {
    extensions: ['azw'],
  },
  'application/vnd.americandynamics.acc': {
    extensions: ['acc'],
  },
  'application/vnd.amiga.ami': {
    extensions: ['ami'],
  },
  'application/vnd.android.package-archive': {
    extensions: ['apk'],
  },
  'application/vnd.anser-web-certificate-issue-initiation': {
    extensions: ['cii'],
  },
  'application/vnd.anser-web-funds-transfer-initiation': {
    extensions: ['fti'],
  },
  'application/vnd.antix.game-component': {
    extensions: ['atx'],
  },
  'application/vnd.apache.parquet': {
    extensions: ['parquet'],
  },
  'application/vnd.apple.installer+xml': {
    extensions: ['mpkg'],
  },
  'application/vnd.apple.keynote': {
    extensions: ['key'],
  },
  'application/vnd.apple.mpegurl': {
    extensions: ['m3u8'],
  },
  'application/vnd.apple.numbers': {
    extensions: ['numbers'],
  },
  'application/vnd.apple.pages': {
    extensions: ['pages'],
  },
  'application/vnd.apple.pkpass': {
    extensions: ['pkpass'],
  },
  'application/vnd.aristanetworks.swi': {
    extensions: ['swi'],
  },
  'application/vnd.astraea-software.iota': {
    extensions: ['iota'],
  },
  'application/vnd.audiograph': {
    extensions: ['aep'],
  },
  'application/vnd.autodesk.fbx': {
    extensions: ['fbx'],
  },
  'application/vnd.balsamiq.bmml+xml': {
    extensions: ['bmml'],
  },
  'application/vnd.blueice.multipass': {
    extensions: ['mpm'],
  },
  'application/vnd.bmi': {
    extensions: ['bmi'],
  },
  'application/vnd.businessobjects': {
    extensions: ['rep'],
  },
  'application/vnd.chemdraw+xml': {
    extensions: ['cdxml'],
  },
  'application/vnd.chipnuts.karaoke-mmd': {
    extensions: ['mmd'],
  },
  'application/vnd.cinderella': {
    extensions: ['cdy'],
  },
  'application/vnd.citationstyles.style+xml': {
    extensions: ['csl'],
  },
  'application/vnd.claymore': {
    extensions: ['cla'],
  },
  'application/vnd.cloanto.rp9': {
    extensions: ['rp9'],
  },
  'application/vnd.clonk.c4group': {
    extensions: ['c4g', 'c4d', 'c4f', 'c4p', 'c4u'],
  },
  'application/vnd.cluetrust.cartomobile-config': {
    extensions: ['c11amc'],
  },
  'application/vnd.cluetrust.cartomobile-config-pkg': {
    extensions: ['c11amz'],
  },
  'application/vnd.commonspace': {
    extensions: ['csp'],
  },
  'application/vnd.contact.cmsg': {
    extensions: ['cdbcmsg'],
  },
  'application/vnd.cosmocaller': {
    extensions: ['cmc'],
  },
  'application/vnd.crick.clicker': {
    extensions: ['clkx'],
  },
  'application/vnd.crick.clicker.keyboard': {
    extensions: ['clkk'],
  },
  'application/vnd.crick.clicker.palette': {
    extensions: ['clkp'],
  },
  'application/vnd.crick.clicker.template': {
    extensions: ['clkt'],
  },
  'application/vnd.crick.clicker.wordbank': {
    extensions: ['clkw'],
  },
  'application/vnd.criticaltools.wbs+xml': {
    extensions: ['wbs'],
  },
  'application/vnd.ctc-posml': {
    extensions: ['pml'],
  },
  'application/vnd.cups-ppd': {
    extensions: ['ppd'],
  },
  'application/vnd.curl.car': {
    extensions: ['car'],
  },
  'application/vnd.curl.pcurl': {
    extensions: ['pcurl'],
  },
  'application/vnd.dart': {
    extensions: ['dart'],
  },
  'application/vnd.data-vision.rdz': {
    extensions: ['rdz'],
  },
  'application/vnd.dbf': {
    extensions: ['dbf'],
  },
  'application/vnd.dcmp+xml': {
    extensions: ['dcmp'],
  },
  'application/vnd.dece.data': {
    extensions: ['uvf', 'uvvf', 'uvd', 'uvvd'],
  },
  'application/vnd.dece.ttml+xml': {
    extensions: ['uvt', 'uvvt'],
  },
  'application/vnd.dece.unspecified': {
    extensions: ['uvx', 'uvvx'],
  },
  'application/vnd.dece.zip': {
    extensions: ['uvz', 'uvvz'],
  },
  'application/vnd.denovo.fcselayout-link': {
    extensions: ['fe_launch'],
  },
  'application/vnd.dna': {
    extensions: ['dna'],
  },
  'application/vnd.dolby.mlp': {
    extensions: ['mlp'],
  },
  'application/vnd.dpgraph': {
    extensions: ['dpg'],
  },
  'application/vnd.dreamfactory': {
    extensions: ['dfac'],
  },
  'application/vnd.ds-keypoint': {
    extensions: ['kpxx'],
  },
  'application/vnd.dvb.ait': {
    extensions: ['ait'],
  },
  'application/vnd.dvb.service': {
    extensions: ['svc'],
  },
  'application/vnd.dynageo': {
    extensions: ['geo'],
  },
  'application/vnd.ecowin.chart': {
    extensions: ['mag'],
  },
  'application/vnd.enliven': {
    extensions: ['nml'],
  },
  'application/vnd.epson.esf': {
    extensions: ['esf'],
  },
  'application/vnd.epson.msf': {
    extensions: ['msf'],
  },
  'application/vnd.epson.quickanime': {
    extensions: ['qam'],
  },
  'application/vnd.epson.salt': {
    extensions: ['slt'],
  },
  'application/vnd.epson.ssf': {
    extensions: ['ssf'],
  },
  'application/vnd.eszigno3+xml': {
    extensions: ['es3', 'et3'],
  },
  'application/vnd.ezpix-album': {
    extensions: ['ez2'],
  },
  'application/vnd.ezpix-package': {
    extensions: ['ez3'],
  },
  'application/vnd.fdf': {
    extensions: ['fdf'],
  },
  'application/vnd.fdsn.mseed': {
    extensions: ['mseed'],
  },
  'application/vnd.fdsn.seed': {
    extensions: ['seed', 'dataless'],
  },
  'application/vnd.flographit': {
    extensions: ['gph'],
  },
  'application/vnd.fluxtime.clip': {
    extensions: ['ftc'],
  },
  'application/vnd.framemaker': {
    extensions: ['fm', 'frame', 'maker', 'book'],
  },
  'application/vnd.frogans.fnc': {
    extensions: ['fnc'],
  },
  'application/vnd.frogans.ltf': {
    extensions: ['ltf'],
  },
  'application/vnd.fsc.weblaunch': {
    extensions: ['fsc'],
  },
  'application/vnd.fujitsu.oasys': {
    extensions: ['oas'],
  },
  'application/vnd.fujitsu.oasys2': {
    extensions: ['oa2'],
  },
  'application/vnd.fujitsu.oasys3': {
    extensions: ['oa3'],
  },
  'application/vnd.fujitsu.oasysgp': {
    extensions: ['fg5'],
  },
  'application/vnd.fujitsu.oasysprs': {
    extensions: ['bh2'],
  },
  'application/vnd.fujixerox.ddd': {
    extensions: ['ddd'],
  },
  'application/vnd.fujixerox.docuworks': {
    extensions: ['xdw'],
  },
  'application/vnd.fujixerox.docuworks.binder': {
    extensions: ['xbd'],
  },
  'application/vnd.fuzzysheet': {
    extensions: ['fzs'],
  },
  'application/vnd.genomatix.tuxedo': {
    extensions: ['txd'],
  },
  'application/vnd.geogebra.file': {
    extensions: ['ggb'],
  },
  'application/vnd.geogebra.slides': {
    extensions: ['ggs'],
  },
  'application/vnd.geogebra.tool': {
    extensions: ['ggt'],
  },
  'application/vnd.geometry-explorer': {
    extensions: ['gex', 'gre'],
  },
  'application/vnd.geonext': {
    extensions: ['gxt'],
  },
  'application/vnd.geoplan': {
    extensions: ['g2w'],
  },
  'application/vnd.geospace': {
    extensions: ['g3w'],
  },
  'application/vnd.gmx': {
    extensions: ['gmx'],
  },
  'application/vnd.google-apps.document': {
    extensions: ['gdoc'],
  },
  'application/vnd.google-apps.drawing': {
    extensions: ['gdraw'],
  },
  'application/vnd.google-apps.form': {
    extensions: ['gform'],
  },
  'application/vnd.google-apps.jam': {
    extensions: ['gjam'],
  },
  'application/vnd.google-apps.map': {
    extensions: ['gmap'],
  },
  'application/vnd.google-apps.presentation': {
    extensions: ['gslides'],
  },
  'application/vnd.google-apps.script': {
    extensions: ['gscript'],
  },
  'application/vnd.google-apps.site': {
    extensions: ['gsite'],
  },
  'application/vnd.google-apps.spreadsheet': {
    extensions: ['gsheet'],
  },
  'application/vnd.google-earth.kml+xml': {
    extensions: ['kml'],
  },
  'application/vnd.google-earth.kmz': {
    extensions: ['kmz'],
  },
  'application/vnd.gov.sk.xmldatacontainer+xml': {
    extensions: ['xdcf'],
  },
  'application/vnd.grafeq': {
    extensions: ['gqf', 'gqs'],
  },
  'application/vnd.groove-account': {
    extensions: ['gac'],
  },
  'application/vnd.groove-help': {
    extensions: ['ghf'],
  },
  'application/vnd.groove-identity-message': {
    extensions: ['gim'],
  },
  'application/vnd.groove-injector': {
    extensions: ['grv'],
  },
  'application/vnd.groove-tool-message': {
    extensions: ['gtm'],
  },
  'application/vnd.groove-tool-template': {
    extensions: ['tpl'],
  },
  'application/vnd.groove-vcard': {
    extensions: ['vcg'],
  },
  'application/vnd.hal+xml': {
    extensions: ['hal'],
  },
  'application/vnd.handheld-entertainment+xml': {
    extensions: ['zmm'],
  },
  'application/vnd.hbci': {
    extensions: ['hbci'],
  },
  'application/vnd.hhe.lesson-player': {
    extensions: ['les'],
  },
  'application/vnd.hp-hpgl': {
    extensions: ['hpgl'],
  },
  'application/vnd.hp-hpid': {
    extensions: ['hpid'],
  },
  'application/vnd.hp-hps': {
    extensions: ['hps'],
  },
  'application/vnd.hp-jlyt': {
    extensions: ['jlt'],
  },
  'application/vnd.hp-pcl': {
    extensions: ['pcl'],
  },
  'application/vnd.hp-pclxl': {
    extensions: ['pclxl'],
  },
  'application/vnd.hydrostatix.sof-data': {
    extensions: ['sfd-hdstx'],
  },
  'application/vnd.ibm.minipay': {
    extensions: ['mpy'],
  },
  'application/vnd.ibm.modcap': {
    extensions: ['afp', 'listafp', 'list3820'],
  },
  'application/vnd.ibm.rights-management': {
    extensions: ['irm'],
  },
  'application/vnd.ibm.secure-container': {
    extensions: ['sc'],
  },
  'application/vnd.iccprofile': {
    extensions: ['icc', 'icm'],
  },
  'application/vnd.igloader': {
    extensions: ['igl'],
  },
  'application/vnd.immervision-ivp': {
    extensions: ['ivp'],
  },
  'application/vnd.immervision-ivu': {
    extensions: ['ivu'],
  },
  'application/vnd.insors.igm': {
    extensions: ['igm'],
  },
  'application/vnd.intercon.formnet': {
    extensions: ['xpw', 'xpx'],
  },
  'application/vnd.intergeo': {
    extensions: ['i2g'],
  },
  'application/vnd.intu.qbo': {
    extensions: ['qbo'],
  },
  'application/vnd.intu.qfx': {
    extensions: ['qfx'],
  },
  'application/vnd.ipunplugged.rcprofile': {
    extensions: ['rcprofile'],
  },
  'application/vnd.irepository.package+xml': {
    extensions: ['irp'],
  },
  'application/vnd.is-xpr': {
    extensions: ['xpr'],
  },
  'application/vnd.isac.fcs': {
    extensions: ['fcs'],
  },
  'application/vnd.jam': {
    extensions: ['jam'],
  },
  'application/vnd.jcp.javame.midlet-rms': {
    extensions: ['rms'],
  },
  'application/vnd.jisp': {
    extensions: ['jisp'],
  },
  'application/vnd.joost.joda-archive': {
    extensions: ['joda'],
  },
  'application/vnd.kahootz': {
    extensions: ['ktz', 'ktr'],
  },
  'application/vnd.kde.karbon': {
    extensions: ['karbon'],
  },
  'application/vnd.kde.kchart': {
    extensions: ['chrt'],
  },
  'application/vnd.kde.kformula': {
    extensions: ['kfo'],
  },
  'application/vnd.kde.kivio': {
    extensions: ['flw'],
  },
  'application/vnd.kde.kontour': {
    extensions: ['kon'],
  },
  'application/vnd.kde.kpresenter': {
    extensions: ['kpr', 'kpt'],
  },
  'application/vnd.kde.kspread': {
    extensions: ['ksp'],
  },
  'application/vnd.kde.kword': {
    extensions: ['kwd', 'kwt'],
  },
  'application/vnd.kenameaapp': {
    extensions: ['htke'],
  },
  'application/vnd.kidspiration': {
    extensions: ['kia'],
  },
  'application/vnd.kinar': {
    extensions: ['kne', 'knp'],
  },
  'application/vnd.koan': {
    extensions: ['skp', 'skd', 'skt', 'skm'],
  },
  'application/vnd.kodak-descriptor': {
    extensions: ['sse'],
  },
  'application/vnd.las.las+xml': {
    extensions: ['lasxml'],
  },
  'application/vnd.llamagraphics.life-balance.desktop': {
    extensions: ['lbd'],
  },
  'application/vnd.llamagraphics.life-balance.exchange+xml': {
    extensions: ['lbe'],
  },
  'application/vnd.lotus-1-2-3': {
    extensions: ['123'],
  },
  'application/vnd.lotus-approach': {
    extensions: ['apr'],
  },
  'application/vnd.lotus-freelance': {
    extensions: ['pre'],
  },
  'application/vnd.lotus-notes': {
    extensions: ['nsf'],
  },
  'application/vnd.lotus-organizer': {
    extensions: ['org'],
  },
  'application/vnd.lotus-screencam': {
    extensions: ['scm'],
  },
  'application/vnd.lotus-wordpro': {
    extensions: ['lwp'],
  },
  'application/vnd.macports.portpkg': {
    extensions: ['portpkg'],
  },
  'application/vnd.mapbox-vector-tile': {
    extensions: ['mvt'],
  },
  'application/vnd.mcd': {
    extensions: ['mcd'],
  },
  'application/vnd.medcalcdata': {
    extensions: ['mc1'],
  },
  'application/vnd.mediastation.cdkey': {
    extensions: ['cdkey'],
  },
  'application/vnd.mfer': {
    extensions: ['mwf'],
  },
  'application/vnd.mfmp': {
    extensions: ['mfm'],
  },
  'application/vnd.micrografx.flo': {
    extensions: ['flo'],
  },
  'application/vnd.micrografx.igx': {
    extensions: ['igx'],
  },
  'application/vnd.mif': {
    extensions: ['mif'],
  },
  'application/vnd.mobius.daf': {
    extensions: ['daf'],
  },
  'application/vnd.mobius.dis': {
    extensions: ['dis'],
  },
  'application/vnd.mobius.mbk': {
    extensions: ['mbk'],
  },
  'application/vnd.mobius.mqy': {
    extensions: ['mqy'],
  },
  'application/vnd.mobius.msl': {
    extensions: ['msl'],
  },
  'application/vnd.mobius.plc': {
    extensions: ['plc'],
  },
  'application/vnd.mobius.txf': {
    extensions: ['txf'],
  },
  'application/vnd.mophun.application': {
    extensions: ['mpn'],
  },
  'application/vnd.mophun.certificate': {
    extensions: ['mpc'],
  },
  'application/vnd.mozilla.xul+xml': {
    extensions: ['xul'],
  },
  'application/vnd.ms-artgalry': {
    extensions: ['cil'],
  },
  'application/vnd.ms-cab-compressed': {
    extensions: ['cab'],
  },
  'application/vnd.ms-excel': {
    extensions: ['xls', 'xlm', 'xla', 'xlc', 'xlt', 'xlw'],
  },
  'application/vnd.ms-excel.addin.macroenabled.12': {
    extensions: ['xlam'],
  },
  'application/vnd.ms-excel.sheet.binary.macroenabled.12': {
    extensions: ['xlsb'],
  },
  'application/vnd.ms-excel.sheet.macroenabled.12': {
    extensions: ['xlsm'],
  },
  'application/vnd.ms-excel.template.macroenabled.12': {
    extensions: ['xltm'],
  },
  'application/vnd.ms-fontobject': {
    extensions: ['eot'],
  },
  'application/vnd.ms-htmlhelp': {
    extensions: ['chm'],
  },
  'application/vnd.ms-ims': {
    extensions: ['ims'],
  },
  'application/vnd.ms-lrm': {
    extensions: ['lrm'],
  },
  'application/vnd.ms-officetheme': {
    extensions: ['thmx'],
  },
  'application/vnd.ms-outlook': {
    extensions: ['msg'],
  },
  'application/vnd.ms-pki.seccat': {
    extensions: ['cat'],
  },
  'application/vnd.ms-pki.stl': {
    extensions: ['stl'],
  },
  'application/vnd.ms-powerpoint': {
    extensions: ['ppt', 'pps', 'pot'],
  },
  'application/vnd.ms-powerpoint.addin.macroenabled.12': {
    extensions: ['ppam'],
  },
  'application/vnd.ms-powerpoint.presentation.macroenabled.12': {
    extensions: ['pptm'],
  },
  'application/vnd.ms-powerpoint.slide.macroenabled.12': {
    extensions: ['sldm'],
  },
  'application/vnd.ms-powerpoint.slideshow.macroenabled.12': {
    extensions: ['ppsm'],
  },
  'application/vnd.ms-powerpoint.template.macroenabled.12': {
    extensions: ['potm'],
  },
  'application/vnd.ms-project': {
    extensions: ['mpp', 'mpt'],
  },
  'application/vnd.ms-visio.viewer': {
    extensions: ['vdx'],
  },
  'application/vnd.ms-word.document.macroenabled.12': {
    extensions: ['docm'],
  },
  'application/vnd.ms-word.template.macroenabled.12': {
    extensions: ['dotm'],
  },
  'application/vnd.ms-works': {
    extensions: ['wps', 'wks', 'wcm', 'wdb'],
  },
  'application/vnd.ms-wpl': {
    extensions: ['wpl'],
  },
  'application/vnd.ms-xpsdocument': {
    extensions: ['xps'],
  },
  'application/vnd.mseq': {
    extensions: ['mseq'],
  },
  'application/vnd.musician': {
    extensions: ['mus'],
  },
  'application/vnd.muvee.style': {
    extensions: ['msty'],
  },
  'application/vnd.mynfc': {
    extensions: ['taglet'],
  },
  'application/vnd.nato.bindingdataobject+xml': {
    extensions: ['bdo'],
  },
  'application/vnd.neurolanguage.nlu': {
    extensions: ['nlu'],
  },
  'application/vnd.nitf': {
    extensions: ['ntf', 'nitf'],
  },
  'application/vnd.noblenet-directory': {
    extensions: ['nnd'],
  },
  'application/vnd.noblenet-sealer': {
    extensions: ['nns'],
  },
  'application/vnd.noblenet-web': {
    extensions: ['nnw'],
  },
  'application/vnd.nokia.n-gage.ac+xml': {
    extensions: ['ac'],
  },
  'application/vnd.nokia.n-gage.data': {
    extensions: ['ngdat'],
  },
  'application/vnd.nokia.n-gage.symbian.install': {
    extensions: ['n-gage'],
  },
  'application/vnd.nokia.radio-preset': {
    extensions: ['rpst'],
  },
  'application/vnd.nokia.radio-presets': {
    extensions: ['rpss'],
  },
  'application/vnd.novadigm.edm': {
    extensions: ['edm'],
  },
  'application/vnd.novadigm.edx': {
    extensions: ['edx'],
  },
  'application/vnd.novadigm.ext': {
    extensions: ['ext'],
  },
  'application/vnd.oasis.opendocument.chart': {
    extensions: ['odc'],
  },
  'application/vnd.oasis.opendocument.chart-template': {
    extensions: ['otc'],
  },
  'application/vnd.oasis.opendocument.database': {
    extensions: ['odb'],
  },
  'application/vnd.oasis.opendocument.formula': {
    extensions: ['odf'],
  },
  'application/vnd.oasis.opendocument.formula-template': {
    extensions: ['odft'],
  },
  'application/vnd.oasis.opendocument.graphics': {
    extensions: ['odg'],
  },
  'application/vnd.oasis.opendocument.graphics-template': {
    extensions: ['otg'],
  },
  'application/vnd.oasis.opendocument.image': {
    extensions: ['odi'],
  },
  'application/vnd.oasis.opendocument.image-template': {
    extensions: ['oti'],
  },
  'application/vnd.oasis.opendocument.presentation': {
    extensions: ['odp'],
  },
  'application/vnd.oasis.opendocument.presentation-template': {
    extensions: ['otp'],
  },
  'application/vnd.oasis.opendocument.spreadsheet': {
    extensions: ['ods'],
  },
  'application/vnd.oasis.opendocument.spreadsheet-template': {
    extensions: ['ots'],
  },
  'application/vnd.oasis.opendocument.text': {
    extensions: ['odt'],
  },
  'application/vnd.oasis.opendocument.text-master': {
    extensions: ['odm'],
  },
  'application/vnd.oasis.opendocument.text-template': {
    extensions: ['ott'],
  },
  'application/vnd.oasis.opendocument.text-web': {
    extensions: ['oth'],
  },
  'application/vnd.olpc-sugar': {
    extensions: ['xo'],
  },
  'application/vnd.oma.dd2+xml': {
    extensions: ['dd2'],
  },
  'application/vnd.openblox.game+xml': {
    extensions: ['obgx'],
  },
  'application/vnd.openofficeorg.extension': {
    extensions: ['oxt'],
  },
  'application/vnd.openstreetmap.data+xml': {
    extensions: ['osm'],
  },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
    extensions: ['pptx'],
  },
  'application/vnd.openxmlformats-officedocument.presentationml.slide': {
    extensions: ['sldx'],
  },
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow': {
    extensions: ['ppsx'],
  },
  'application/vnd.openxmlformats-officedocument.presentationml.template': {
    extensions: ['potx'],
  },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    extensions: ['xlsx'],
  },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template': {
    extensions: ['xltx'],
  },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    extensions: ['docx'],
  },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template': {
    extensions: ['dotx'],
  },
  'application/vnd.osgeo.mapguide.package': {
    extensions: ['mgp'],
  },
  'application/vnd.osgi.dp': {
    extensions: ['dp'],
  },
  'application/vnd.osgi.subsystem': {
    extensions: ['esa'],
  },
  'application/vnd.palm': {
    extensions: ['pdb', 'pqa', 'oprc'],
  },
  'application/vnd.pawaafile': {
    extensions: ['paw'],
  },
  'application/vnd.pg.format': {
    extensions: ['str'],
  },
  'application/vnd.pg.osasli': {
    extensions: ['ei6'],
  },
  'application/vnd.picsel': {
    extensions: ['efif'],
  },
  'application/vnd.pmi.widget': {
    extensions: ['wg'],
  },
  'application/vnd.pocketlearn': {
    extensions: ['plf'],
  },
  'application/vnd.powerbuilder6': {
    extensions: ['pbd'],
  },
  'application/vnd.pp.systemverify+xml': {
    extensions: ['systemverify'],
  },
  'application/vnd.previewsystems.box': {
    extensions: ['box'],
  },
  'application/vnd.procreate.brush': {
    extensions: ['brush'],
  },
  'application/vnd.procreate.brushset': {
    extensions: ['brushset'],
  },
  'application/vnd.procreate.dream': {
    extensions: ['drm'],
  },
  'application/vnd.proteus.magazine': {
    extensions: ['mgz'],
  },
  'application/vnd.publishare-delta-tree': {
    extensions: ['qps'],
  },
  'application/vnd.pvi.ptid1': {
    extensions: ['ptid'],
  },
  'application/vnd.pwg-xhtml-print+xml': {
    extensions: ['xhtm'],
  },
  'application/vnd.quark.quarkxpress': {
    extensions: ['qxd', 'qxt', 'qwd', 'qwt', 'qxl', 'qxb'],
  },
  'application/vnd.rar': {
    extensions: ['rar'],
  },
  'application/vnd.realvnc.bed': {
    extensions: ['bed'],
  },
  'application/vnd.recordare.musicxml': {
    extensions: ['mxl'],
  },
  'application/vnd.recordare.musicxml+xml': {
    extensions: ['musicxml'],
  },
  'application/vnd.rig.cryptonote': {
    extensions: ['cryptonote'],
  },
  'application/vnd.rim.cod': {
    extensions: ['cod'],
  },
  'application/vnd.rn-realmedia': {
    extensions: ['rm'],
  },
  'application/vnd.rn-realmedia-vbr': {
    extensions: ['rmvb'],
  },
  'application/vnd.route66.link66+xml': {
    extensions: ['link66'],
  },
  'application/vnd.sailingtracker.track': {
    extensions: ['st'],
  },
  'application/vnd.seemail': {
    extensions: ['see'],
  },
  'application/vnd.sema': {
    extensions: ['sema'],
  },
  'application/vnd.semd': {
    extensions: ['semd'],
  },
  'application/vnd.semf': {
    extensions: ['semf'],
  },
  'application/vnd.shana.informed.formdata': {
    extensions: ['ifm'],
  },
  'application/vnd.shana.informed.formtemplate': {
    extensions: ['itp'],
  },
  'application/vnd.shana.informed.interchange': {
    extensions: ['iif'],
  },
  'application/vnd.shana.informed.package': {
    extensions: ['ipk'],
  },
  'application/vnd.simtech-mindmapper': {
    extensions: ['twd', 'twds'],
  },
  'application/vnd.smaf': {
    extensions: ['mmf'],
  },
  'application/vnd.smart.teacher': {
    extensions: ['teacher'],
  },
  'application/vnd.software602.filler.form+xml': {
    extensions: ['fo'],
  },
  'application/vnd.solent.sdkm+xml': {
    extensions: ['sdkm', 'sdkd'],
  },
  'application/vnd.spotfire.dxp': {
    extensions: ['dxp'],
  },
  'application/vnd.spotfire.sfs': {
    extensions: ['sfs'],
  },
  'application/vnd.sqlite3': {
    extensions: ['sqlite', 'sqlite3'],
  },
  'application/vnd.stardivision.calc': {
    extensions: ['sdc'],
  },
  'application/vnd.stardivision.draw': {
    extensions: ['sda'],
  },
  'application/vnd.stardivision.impress': {
    extensions: ['sdd'],
  },
  'application/vnd.stardivision.math': {
    extensions: ['smf'],
  },
  'application/vnd.stardivision.writer': {
    extensions: ['sdw', 'vor'],
  },
  'application/vnd.stardivision.writer-global': {
    extensions: ['sgl'],
  },
  'application/vnd.stepmania.package': {
    extensions: ['smzip'],
  },
  'application/vnd.stepmania.stepchart': {
    extensions: ['sm'],
  },
  'application/vnd.sun.wadl+xml': {
    extensions: ['wadl'],
  },
  'application/vnd.sun.xml.calc': {
    extensions: ['sxc'],
  },
  'application/vnd.sun.xml.calc.template': {
    extensions: ['stc'],
  },
  'application/vnd.sun.xml.draw': {
    extensions: ['sxd'],
  },
  'application/vnd.sun.xml.draw.template': {
    extensions: ['std'],
  },
  'application/vnd.sun.xml.impress': {
    extensions: ['sxi'],
  },
  'application/vnd.sun.xml.impress.template': {
    extensions: ['sti'],
  },
  'application/vnd.sun.xml.math': {
    extensions: ['sxm'],
  },
  'application/vnd.sun.xml.writer': {
    extensions: ['sxw'],
  },
  'application/vnd.sun.xml.writer.global': {
    extensions: ['sxg'],
  },
  'application/vnd.sun.xml.writer.template': {
    extensions: ['stw'],
  },
  'application/vnd.sus-calendar': {
    extensions: ['sus', 'susp'],
  },
  'application/vnd.svd': {
    extensions: ['svd'],
  },
  'application/vnd.symbian.install': {
    extensions: ['sis', 'sisx'],
  },
  'application/vnd.syncml+xml': {
    extensions: ['xsm'],
  },
  'application/vnd.syncml.dm+wbxml': {
    extensions: ['bdm'],
  },
  'application/vnd.syncml.dm+xml': {
    extensions: ['xdm'],
  },
  'application/vnd.syncml.dmddf+xml': {
    extensions: ['ddf'],
  },
  'application/vnd.tao.intent-module-archive': {
    extensions: ['tao'],
  },
  'application/vnd.tcpdump.pcap': {
    extensions: ['pcap', 'cap', 'dmp'],
  },
  'application/vnd.tmobile-livetv': {
    extensions: ['tmo'],
  },
  'application/vnd.trid.tpt': {
    extensions: ['tpt'],
  },
  'application/vnd.triscape.mxs': {
    extensions: ['mxs'],
  },
  'application/vnd.trueapp': {
    extensions: ['tra'],
  },
  'application/vnd.ufdl': {
    extensions: ['ufd', 'ufdl'],
  },
  'application/vnd.uiq.theme': {
    extensions: ['utz'],
  },
  'application/vnd.umajin': {
    extensions: ['umj'],
  },
  'application/vnd.unity': {
    extensions: ['unityweb'],
  },
  'application/vnd.uoml+xml': {
    extensions: ['uoml', 'uo'],
  },
  'application/vnd.vcx': {
    extensions: ['vcx'],
  },
  'application/vnd.visio': {
    extensions: ['vsd', 'vst', 'vss', 'vsw', 'vsdx', 'vtx'],
  },
  'application/vnd.visionary': {
    extensions: ['vis'],
  },
  'application/vnd.vsf': {
    extensions: ['vsf'],
  },
  'application/vnd.wap.wbxml': {
    extensions: ['wbxml'],
  },
  'application/vnd.wap.wmlc': {
    extensions: ['wmlc'],
  },
  'application/vnd.wap.wmlscriptc': {
    extensions: ['wmlsc'],
  },
  'application/vnd.webturbo': {
    extensions: ['wtb'],
  },
  'application/vnd.wolfram.player': {
    extensions: ['nbp'],
  },
  'application/vnd.wordperfect': {
    extensions: ['wpd'],
  },
  'application/vnd.wqd': {
    extensions: ['wqd'],
  },
  'application/vnd.wt.stf': {
    extensions: ['stf'],
  },
  'application/vnd.xara': {
    extensions: ['xar'],
  },
  'application/vnd.xfdl': {
    extensions: ['xfdl'],
  },
  'application/vnd.yamaha.hv-dic': {
    extensions: ['hvd'],
  },
  'application/vnd.yamaha.hv-script': {
    extensions: ['hvs'],
  },
  'application/vnd.yamaha.hv-voice': {
    extensions: ['hvp'],
  },
  'application/vnd.yamaha.openscoreformat': {
    extensions: ['osf'],
  },
  'application/vnd.yamaha.openscoreformat.osfpvg+xml': {
    extensions: ['osfpvg'],
  },
  'application/vnd.yamaha.smaf-audio': {
    extensions: ['saf'],
  },
  'application/vnd.yamaha.smaf-phrase': {
    extensions: ['spf'],
  },
  'application/vnd.yellowriver-custom-menu': {
    extensions: ['cmp'],
  },
  'application/vnd.zul': {
    extensions: ['zir', 'zirz'],
  },
  'application/vnd.zzazz.deck+xml': {
    extensions: ['zaz'],
  },
  'application/voicexml+xml': {
    extensions: ['vxml'],
  },
  'application/wasm': {
    extensions: ['wasm'],
  },
  'application/watcherinfo+xml': {
    extensions: ['wif'],
  },
  'application/widget': {
    extensions: ['wgt'],
  },
  'application/winhlp': {
    extensions: ['hlp'],
  },
  'application/wsdl+xml': {
    extensions: ['wsdl'],
  },
  'application/wspolicy+xml': {
    extensions: ['wspolicy'],
  },
  'application/x-7z-compressed': {
    extensions: ['7z'],
  },
  'application/x-abiword': {
    extensions: ['abw'],
  },
  'application/x-ace-compressed': {
    extensions: ['ace'],
  },
  'application/x-apple-diskimage': {
    extensions: ['dmg'],
  },
  'application/x-arj': {
    extensions: ['arj'],
  },
  'application/x-authorware-bin': {
    extensions: ['aab', 'x32', 'u32', 'vox'],
  },
  'application/x-authorware-map': {
    extensions: ['aam'],
  },
  'application/x-authorware-seg': {
    extensions: ['aas'],
  },
  'application/x-bcpio': {
    extensions: ['bcpio'],
  },
  'application/x-bdoc': {
    extensions: ['bdoc'],
  },
  'application/x-bittorrent': {
    extensions: ['torrent'],
  },
  'application/x-blender': {
    extensions: ['blend'],
  },
  'application/x-blorb': {
    extensions: ['blb', 'blorb'],
  },
  'application/x-bzip': {
    extensions: ['bz'],
  },
  'application/x-bzip2': {
    extensions: ['bz2', 'boz'],
  },
  'application/x-cbr': {
    extensions: ['cbr', 'cba', 'cbt', 'cbz', 'cb7'],
  },
  'application/x-cdlink': {
    extensions: ['vcd'],
  },
  'application/x-cfs-compressed': {
    extensions: ['cfs'],
  },
  'application/x-chat': {
    extensions: ['chat'],
  },
  'application/x-chess-pgn': {
    extensions: ['pgn'],
  },
  'application/x-chrome-extension': {
    extensions: ['crx'],
  },
  'application/x-cocoa': {
    extensions: ['cco'],
  },
  'application/x-compressed': {
    extensions: ['rar'],
  },
  'application/x-conference': {
    extensions: ['nsc'],
  },
  'application/x-cpio': {
    extensions: ['cpio'],
  },
  'application/x-csh': {
    extensions: ['csh'],
  },
  'application/x-debian-package': {
    extensions: ['deb', 'udeb'],
  },
  'application/x-dgc-compressed': {
    extensions: ['dgc'],
  },
  'application/x-director': {
    extensions: ['dir', 'dcr', 'dxr', 'cst', 'cct', 'cxt', 'w3d', 'fgd', 'swa'],
  },
  'application/x-doom': {
    extensions: ['wad'],
  },
  'application/x-dtbncx+xml': {
    extensions: ['ncx'],
  },
  'application/x-dtbook+xml': {
    extensions: ['dtb'],
  },
  'application/x-dtbresource+xml': {
    extensions: ['res'],
  },
  'application/x-dvi': {
    extensions: ['dvi'],
  },
  'application/x-envoy': {
    extensions: ['evy'],
  },
  'application/x-eva': {
    extensions: ['eva'],
  },
  'application/x-font-bdf': {
    extensions: ['bdf'],
  },
  'application/x-font-ghostscript': {
    extensions: ['gsf'],
  },
  'application/x-font-linux-psf': {
    extensions: ['psf'],
  },
  'application/x-font-pcf': {
    extensions: ['pcf'],
  },
  'application/x-font-snf': {
    extensions: ['snf'],
  },
  'application/x-font-type1': {
    extensions: ['pfa', 'pfb', 'pfm', 'afm'],
  },
  'application/x-freearc': {
    extensions: ['arc'],
  },
  'application/x-futuresplash': {
    extensions: ['spl'],
  },
  'application/x-gca-compressed': {
    extensions: ['gca'],
  },
  'application/x-glulx': {
    extensions: ['ulx'],
  },
  'application/x-gnumeric': {
    extensions: ['gnumeric'],
  },
  'application/x-gramps-xml': {
    extensions: ['gramps'],
  },
  'application/x-gtar': {
    extensions: ['gtar'],
  },
  'application/x-hdf': {
    extensions: ['hdf'],
  },
  'application/x-httpd-php': {
    extensions: ['php'],
  },
  'application/x-install-instructions': {
    extensions: ['install'],
  },
  'application/x-ipynb+json': {
    extensions: ['ipynb'],
  },
  'application/x-iso9660-image': {
    extensions: ['iso'],
  },
  'application/x-iwork-keynote-sffkey': {
    extensions: ['key'],
  },
  'application/x-iwork-numbers-sffnumbers': {
    extensions: ['numbers'],
  },
  'application/x-iwork-pages-sffpages': {
    extensions: ['pages'],
  },
  'application/x-java-archive-diff': {
    extensions: ['jardiff'],
  },
  'application/x-java-jnlp-file': {
    extensions: ['jnlp'],
  },
  'application/x-keepass2': {
    extensions: ['kdbx'],
  },
  'application/x-latex': {
    extensions: ['latex'],
  },
  'application/x-lua-bytecode': {
    extensions: ['luac'],
  },
  'application/x-lzh-compressed': {
    extensions: ['lzh', 'lha'],
  },
  'application/x-makeself': {
    extensions: ['run'],
  },
  'application/x-mie': {
    extensions: ['mie'],
  },
  'application/x-mobipocket-ebook': {
    extensions: ['prc', 'mobi'],
  },
  'application/x-ms-application': {
    extensions: ['application'],
  },
  'application/x-ms-shortcut': {
    extensions: ['lnk'],
  },
  'application/x-ms-wmd': {
    extensions: ['wmd'],
  },
  'application/x-ms-wmz': {
    extensions: ['wmz'],
  },
  'application/x-ms-xbap': {
    extensions: ['xbap'],
  },
  'application/x-msaccess': {
    extensions: ['mdb'],
  },
  'application/x-msbinder': {
    extensions: ['obd'],
  },
  'application/x-mscardfile': {
    extensions: ['crd'],
  },
  'application/x-msclip': {
    extensions: ['clp'],
  },
  'application/x-msdos-program': {
    extensions: ['exe'],
  },
  'application/x-msdownload': {
    extensions: ['exe', 'dll', 'com', 'bat', 'msi'],
  },
  'application/x-msmediaview': {
    extensions: ['mvb', 'm13', 'm14'],
  },
  'application/x-msmetafile': {
    extensions: ['wmf', 'wmz', 'emf', 'emz'],
  },
  'application/x-msmoney': {
    extensions: ['mny'],
  },
  'application/x-mspublisher': {
    extensions: ['pub'],
  },
  'application/x-msschedule': {
    extensions: ['scd'],
  },
  'application/x-msterminal': {
    extensions: ['trm'],
  },
  'application/x-mswrite': {
    extensions: ['wri'],
  },
  'application/x-netcdf': {
    extensions: ['nc', 'cdf'],
  },
  'application/x-ns-proxy-autoconfig': {
    extensions: ['pac'],
  },
  'application/x-nzb': {
    extensions: ['nzb'],
  },
  'application/x-perl': {
    extensions: ['pl', 'pm'],
  },
  'application/x-pilot': {
    extensions: ['prc', 'pdb'],
  },
  'application/x-pkcs12': {
    extensions: ['p12', 'pfx'],
  },
  'application/x-pkcs7-certificates': {
    extensions: ['p7b', 'spc'],
  },
  'application/x-pkcs7-certreqresp': {
    extensions: ['p7r'],
  },
  'application/x-rar-compressed': {
    extensions: ['rar'],
  },
  'application/x-redhat-package-manager': {
    extensions: ['rpm'],
  },
  'application/x-research-info-systems': {
    extensions: ['ris'],
  },
  'application/x-sea': {
    extensions: ['sea'],
  },
  'application/x-sh': {
    extensions: ['sh'],
  },
  'application/x-shar': {
    extensions: ['shar'],
  },
  'application/x-shockwave-flash': {
    extensions: ['swf'],
  },
  'application/x-silverlight-app': {
    extensions: ['xap'],
  },
  'application/x-sql': {
    extensions: ['sql'],
  },
  'application/x-stuffit': {
    extensions: ['sit'],
  },
  'application/x-stuffitx': {
    extensions: ['sitx'],
  },
  'application/x-subrip': {
    extensions: ['srt'],
  },
  'application/x-sv4cpio': {
    extensions: ['sv4cpio'],
  },
  'application/x-sv4crc': {
    extensions: ['sv4crc'],
  },
  'application/x-t3vm-image': {
    extensions: ['t3'],
  },
  'application/x-tads': {
    extensions: ['gam'],
  },
  'application/x-tar': {
    extensions: ['tar'],
  },
  'application/x-tcl': {
    extensions: ['tcl', 'tk'],
  },
  'application/x-tex': {
    extensions: ['tex'],
  },
  'application/x-tex-tfm': {
    extensions: ['tfm'],
  },
  'application/x-texinfo': {
    extensions: ['texinfo', 'texi'],
  },
  'application/x-tgif': {
    extensions: ['obj'],
  },
  'application/x-ustar': {
    extensions: ['ustar'],
  },
  'application/x-virtualbox-hdd': {
    extensions: ['hdd'],
  },
  'application/x-virtualbox-ova': {
    extensions: ['ova'],
  },
  'application/x-virtualbox-ovf': {
    extensions: ['ovf'],
  },
  'application/x-virtualbox-vbox': {
    extensions: ['vbox'],
  },
  'application/x-virtualbox-vbox-extpack': {
    extensions: ['vbox-extpack'],
  },
  'application/x-virtualbox-vdi': {
    extensions: ['vdi'],
  },
  'application/x-virtualbox-vhd': {
    extensions: ['vhd'],
  },
  'application/x-virtualbox-vmdk': {
    extensions: ['vmdk'],
  },
  'application/x-wais-source': {
    extensions: ['src'],
  },
  'application/x-web-app-manifest+json': {
    extensions: ['webapp'],
  },
  'application/x-x509-ca-cert': {
    extensions: ['der', 'crt', 'pem'],
  },
  'application/x-xfig': {
    extensions: ['fig'],
  },
  'application/x-xliff+xml': {
    extensions: ['xlf'],
  },
  'application/x-xpinstall': {
    extensions: ['xpi'],
  },
  'application/x-xz': {
    extensions: ['xz'],
  },
  'application/x-zip-compressed': {
    extensions: ['zip'],
  },
  'application/x-zmachine': {
    extensions: ['z1', 'z2', 'z3', 'z4', 'z5', 'z6', 'z7', 'z8'],
  },
  'application/xaml+xml': {
    extensions: ['xaml'],
  },
  'application/xcap-att+xml': {
    extensions: ['xav'],
  },
  'application/xcap-caps+xml': {
    extensions: ['xca'],
  },
  'application/xcap-diff+xml': {
    extensions: ['xdf'],
  },
  'application/xcap-el+xml': {
    extensions: ['xel'],
  },
  'application/xcap-ns+xml': {
    extensions: ['xns'],
  },
  'application/xenc+xml': {
    extensions: ['xenc'],
  },
  'application/xfdf': {
    extensions: ['xfdf'],
  },
  'application/xhtml+xml': {
    extensions: ['xhtml', 'xht'],
  },
  'application/xliff+xml': {
    extensions: ['xlf'],
  },
  'application/xml': {
    extensions: ['xml', 'xsl', 'xsd', 'rng'],
  },
  'application/xml-dtd': {
    extensions: ['dtd'],
  },
  'application/xop+xml': {
    extensions: ['xop'],
  },
  'application/xproc+xml': {
    extensions: ['xpl'],
  },
  'application/xslt+xml': {
    extensions: ['xsl', 'xslt'],
  },
  'application/xspf+xml': {
    extensions: ['xspf'],
  },
  'application/xv+xml': {
    extensions: ['mxml', 'xhvml', 'xvml', 'xvm'],
  },
  'application/yang': {
    extensions: ['yang'],
  },
  'application/yin+xml': {
    extensions: ['yin'],
  },
  'application/zip': {
    extensions: ['zip'],
  },
  'application/zip+dotlottie': {
    extensions: ['lottie'],
  },
  'audio/3gpp': {
    extensions: ['3gpp'],
  },
  'audio/aac': {
    extensions: ['adts', 'aac'],
  },
  'audio/adpcm': {
    extensions: ['adp'],
  },
  'audio/amr': {
    extensions: ['amr'],
  },
  'audio/basic': {
    extensions: ['au', 'snd'],
  },
  'audio/matroska': {
    extensions: ['mka'],
  },
  'audio/midi': {
    extensions: ['mid', 'midi', 'kar', 'rmi'],
  },
  'audio/mobile-xmf': {
    extensions: ['mxmf'],
  },
  'audio/mp3': {
    extensions: ['mp3'],
  },
  'audio/mp4': {
    extensions: ['m4a', 'mp4a', 'm4b'],
  },
  'audio/mpeg': {
    extensions: ['mpga', 'mp2', 'mp2a', 'mp3', 'm2a', 'm3a'],
  },
  'audio/ogg': {
    extensions: ['oga', 'ogg', 'spx', 'opus'],
  },
  'audio/s3m': {
    extensions: ['s3m'],
  },
  'audio/silk': {
    extensions: ['sil'],
  },
  'audio/vnd.dece.audio': {
    extensions: ['uva', 'uvva'],
  },
  'audio/vnd.digital-winds': {
    extensions: ['eol'],
  },
  'audio/vnd.dra': {
    extensions: ['dra'],
  },
  'audio/vnd.dts': {
    extensions: ['dts'],
  },
  'audio/vnd.dts.hd': {
    extensions: ['dtshd'],
  },
  'audio/vnd.lucent.voice': {
    extensions: ['lvp'],
  },
  'audio/vnd.ms-playready.media.pya': {
    extensions: ['pya'],
  },
  'audio/vnd.nuera.ecelp4800': {
    extensions: ['ecelp4800'],
  },
  'audio/vnd.nuera.ecelp7470': {
    extensions: ['ecelp7470'],
  },
  'audio/vnd.nuera.ecelp9600': {
    extensions: ['ecelp9600'],
  },
  'audio/vnd.rip': {
    extensions: ['rip'],
  },
  'audio/wav': {
    extensions: ['wav'],
  },
  'audio/wave': {
    extensions: ['wav'],
  },
  'audio/webm': {
    extensions: ['weba'],
  },
  'audio/x-aac': {
    extensions: ['aac'],
  },
  'audio/x-aiff': {
    extensions: ['aif', 'aiff', 'aifc'],
  },
  'audio/x-caf': {
    extensions: ['caf'],
  },
  'audio/x-flac': {
    extensions: ['flac'],
  },
  'audio/x-m4a': {
    extensions: ['m4a'],
  },
  'audio/x-matroska': {
    extensions: ['mka'],
  },
  'audio/x-mpegurl': {
    extensions: ['m3u'],
  },
  'audio/x-ms-wax': {
    extensions: ['wax'],
  },
  'audio/x-ms-wma': {
    extensions: ['wma'],
  },
  'audio/x-pn-realaudio': {
    extensions: ['ram', 'ra'],
  },
  'audio/x-pn-realaudio-plugin': {
    extensions: ['rmp'],
  },
  'audio/x-realaudio': {
    extensions: ['ra'],
  },
  'audio/x-wav': {
    extensions: ['wav'],
  },
  'audio/xm': {
    extensions: ['xm'],
  },
  'chemical/x-cdx': {
    extensions: ['cdx'],
  },
  'chemical/x-cif': {
    extensions: ['cif'],
  },
  'chemical/x-cmdf': {
    extensions: ['cmdf'],
  },
  'chemical/x-cml': {
    extensions: ['cml'],
  },
  'chemical/x-csml': {
    extensions: ['csml'],
  },
  'chemical/x-xyz': {
    extensions: ['xyz'],
  },
  'font/collection': {
    extensions: ['ttc'],
  },
  'font/otf': {
    extensions: ['otf'],
  },
  'font/ttf': {
    extensions: ['ttf'],
  },
  'font/woff': {
    extensions: ['woff'],
  },
  'font/woff2': {
    extensions: ['woff2'],
  },
  'image/aces': {
    extensions: ['exr'],
  },
  'image/apng': {
    extensions: ['apng'],
  },
  'image/avci': {
    extensions: ['avci'],
  },
  'image/avcs': {
    extensions: ['avcs'],
  },
  'image/avif': {
    extensions: ['avif'],
  },
  'image/bmp': {
    extensions: ['bmp', 'dib'],
  },
  'image/cgm': {
    extensions: ['cgm'],
  },
  'image/dicom-rle': {
    extensions: ['drle'],
  },
  'image/dpx': {
    extensions: ['dpx'],
  },
  'image/emf': {
    extensions: ['emf'],
  },
  'image/fits': {
    extensions: ['fits'],
  },
  'image/g3fax': {
    extensions: ['g3'],
  },
  'image/gif': {
    extensions: ['gif'],
  },
  'image/heic': {
    extensions: ['heic'],
  },
  'image/heic-sequence': {
    extensions: ['heics'],
  },
  'image/heif': {
    extensions: ['heif'],
  },
  'image/heif-sequence': {
    extensions: ['heifs'],
  },
  'image/hej2k': {
    extensions: ['hej2'],
  },
  'image/ief': {
    extensions: ['ief'],
  },
  'image/jaii': {
    extensions: ['jaii'],
  },
  'image/jais': {
    extensions: ['jais'],
  },
  'image/jls': {
    extensions: ['jls'],
  },
  'image/jp2': {
    extensions: ['jp2', 'jpg2'],
  },
  'image/jpeg': {
    extensions: ['jpg', 'jpeg', 'jpe'],
  },
  'image/jph': {
    extensions: ['jph'],
  },
  'image/jphc': {
    extensions: ['jhc'],
  },
  'image/jpm': {
    extensions: ['jpm', 'jpgm'],
  },
  'image/jpx': {
    extensions: ['jpx', 'jpf'],
  },
  'image/jxl': {
    extensions: ['jxl'],
  },
  'image/jxr': {
    extensions: ['jxr'],
  },
  'image/jxra': {
    extensions: ['jxra'],
  },
  'image/jxrs': {
    extensions: ['jxrs'],
  },
  'image/jxs': {
    extensions: ['jxs'],
  },
  'image/jxsc': {
    extensions: ['jxsc'],
  },
  'image/jxsi': {
    extensions: ['jxsi'],
  },
  'image/jxss': {
    extensions: ['jxss'],
  },
  'image/ktx': {
    extensions: ['ktx'],
  },
  'image/ktx2': {
    extensions: ['ktx2'],
  },
  'image/pjpeg': {
    extensions: ['jfif'],
  },
  'image/png': {
    extensions: ['png'],
  },
  'image/prs.btif': {
    extensions: ['btif', 'btf'],
  },
  'image/prs.pti': {
    extensions: ['pti'],
  },
  'image/sgi': {
    extensions: ['sgi'],
  },
  'image/svg+xml': {
    extensions: ['svg', 'svgz'],
  },
  'image/t38': {
    extensions: ['t38'],
  },
  'image/tiff': {
    extensions: ['tif', 'tiff'],
  },
  'image/tiff-fx': {
    extensions: ['tfx'],
  },
  'image/vnd.adobe.photoshop': {
    extensions: ['psd'],
  },
  'image/vnd.airzip.accelerator.azv': {
    extensions: ['azv'],
  },
  'image/vnd.blockfact.facti': {
    extensions: ['facti'],
  },
  'image/vnd.dece.graphic': {
    extensions: ['uvi', 'uvvi', 'uvg', 'uvvg'],
  },
  'image/vnd.djvu': {
    extensions: ['djvu', 'djv'],
  },
  'image/vnd.dvb.subtitle': {
    extensions: ['sub'],
  },
  'image/vnd.dwg': {
    extensions: ['dwg'],
  },
  'image/vnd.dxf': {
    extensions: ['dxf'],
  },
  'image/vnd.fastbidsheet': {
    extensions: ['fbs'],
  },
  'image/vnd.fpx': {
    extensions: ['fpx'],
  },
  'image/vnd.fst': {
    extensions: ['fst'],
  },
  'image/vnd.fujixerox.edmics-mmr': {
    extensions: ['mmr'],
  },
  'image/vnd.fujixerox.edmics-rlc': {
    extensions: ['rlc'],
  },
  'image/vnd.microsoft.icon': {
    extensions: ['ico'],
  },
  'image/vnd.ms-dds': {
    extensions: ['dds'],
  },
  'image/vnd.ms-modi': {
    extensions: ['mdi'],
  },
  'image/vnd.ms-photo': {
    extensions: ['wdp'],
  },
  'image/vnd.net-fpx': {
    extensions: ['npx'],
  },
  'image/vnd.pco.b16': {
    extensions: ['b16'],
  },
  'image/vnd.tencent.tap': {
    extensions: ['tap'],
  },
  'image/vnd.valve.source.texture': {
    extensions: ['vtf'],
  },
  'image/vnd.wap.wbmp': {
    extensions: ['wbmp'],
  },
  'image/vnd.xiff': {
    extensions: ['xif'],
  },
  'image/vnd.zbrush.pcx': {
    extensions: ['pcx'],
  },
  'image/webp': {
    extensions: ['webp'],
  },
  'image/wmf': {
    extensions: ['wmf'],
  },
  'image/x-3ds': {
    extensions: ['3ds'],
  },
  'image/x-adobe-dng': {
    extensions: ['dng'],
  },
  'image/x-cmu-raster': {
    extensions: ['ras'],
  },
  'image/x-cmx': {
    extensions: ['cmx'],
  },
  'image/x-freehand': {
    extensions: ['fh', 'fhc', 'fh4', 'fh5', 'fh7'],
  },
  'image/x-icon': {
    extensions: ['ico'],
  },
  'image/x-jng': {
    extensions: ['jng'],
  },
  'image/x-mrsid-image': {
    extensions: ['sid'],
  },
  'image/x-ms-bmp': {
    extensions: ['bmp'],
  },
  'image/x-pcx': {
    extensions: ['pcx'],
  },
  'image/x-pict': {
    extensions: ['pic', 'pct'],
  },
  'image/x-portable-anymap': {
    extensions: ['pnm'],
  },
  'image/x-portable-bitmap': {
    extensions: ['pbm'],
  },
  'image/x-portable-graymap': {
    extensions: ['pgm'],
  },
  'image/x-portable-pixmap': {
    extensions: ['ppm'],
  },
  'image/x-rgb': {
    extensions: ['rgb'],
  },
  'image/x-tga': {
    extensions: ['tga'],
  },
  'image/x-xbitmap': {
    extensions: ['xbm'],
  },
  'image/x-xpixmap': {
    extensions: ['xpm'],
  },
  'image/x-xwindowdump': {
    extensions: ['xwd'],
  },
  'message/disposition-notification': {
    extensions: ['disposition-notification'],
  },
  'message/global': {
    extensions: ['u8msg'],
  },
  'message/global-delivery-status': {
    extensions: ['u8dsn'],
  },
  'message/global-disposition-notification': {
    extensions: ['u8mdn'],
  },
  'message/global-headers': {
    extensions: ['u8hdr'],
  },
  'message/rfc822': {
    extensions: ['eml', 'mime', 'mht', 'mhtml'],
  },
  'message/vnd.wfa.wsc': {
    extensions: ['wsc'],
  },
  'model/3mf': {
    extensions: ['3mf'],
  },
  'model/gltf+json': {
    extensions: ['gltf'],
  },
  'model/gltf-binary': {
    extensions: ['glb'],
  },
  'model/iges': {
    extensions: ['igs', 'iges'],
  },
  'model/jt': {
    extensions: ['jt'],
  },
  'model/mesh': {
    extensions: ['msh', 'mesh', 'silo'],
  },
  'model/mtl': {
    extensions: ['mtl'],
  },
  'model/obj': {
    extensions: ['obj'],
  },
  'model/prc': {
    extensions: ['prc'],
  },
  'model/step': {
    extensions: ['step', 'stp', 'stpnc', 'p21', '210'],
  },
  'model/step+xml': {
    extensions: ['stpx'],
  },
  'model/step+zip': {
    extensions: ['stpz'],
  },
  'model/step-xml+zip': {
    extensions: ['stpxz'],
  },
  'model/stl': {
    extensions: ['stl'],
  },
  'model/u3d': {
    extensions: ['u3d'],
  },
  'model/vnd.bary': {
    extensions: ['bary'],
  },
  'model/vnd.cld': {
    extensions: ['cld'],
  },
  'model/vnd.collada+xml': {
    extensions: ['dae'],
  },
  'model/vnd.dwf': {
    extensions: ['dwf'],
  },
  'model/vnd.gdl': {
    extensions: ['gdl'],
  },
  'model/vnd.gtw': {
    extensions: ['gtw'],
  },
  'model/vnd.mts': {
    extensions: ['mts'],
  },
  'model/vnd.opengex': {
    extensions: ['ogex'],
  },
  'model/vnd.parasolid.transmit.binary': {
    extensions: ['x_b'],
  },
  'model/vnd.parasolid.transmit.text': {
    extensions: ['x_t'],
  },
  'model/vnd.pytha.pyox': {
    extensions: ['pyo', 'pyox'],
  },
  'model/vnd.sap.vds': {
    extensions: ['vds'],
  },
  'model/vnd.usda': {
    extensions: ['usda'],
  },
  'model/vnd.usdz+zip': {
    extensions: ['usdz'],
  },
  'model/vnd.valve.source.compiled-map': {
    extensions: ['bsp'],
  },
  'model/vnd.vtu': {
    extensions: ['vtu'],
  },
  'model/vrml': {
    extensions: ['wrl', 'vrml'],
  },
  'model/x3d+binary': {
    extensions: ['x3db', 'x3dbz'],
  },
  'model/x3d+fastinfoset': {
    extensions: ['x3db'],
  },
  'model/x3d+vrml': {
    extensions: ['x3dv', 'x3dvz'],
  },
  'model/x3d+xml': {
    extensions: ['x3d', 'x3dz'],
  },
  'model/x3d-vrml': {
    extensions: ['x3dv'],
  },
  'text/cache-manifest': {
    extensions: ['appcache', 'manifest'],
  },
  'text/calendar': {
    extensions: ['ics', 'ifb'],
  },
  'text/coffeescript': {
    extensions: ['coffee', 'litcoffee'],
  },
  'text/css': {
    extensions: ['css'],
  },
  'text/csv': {
    extensions: ['csv'],
  },
  'text/html': {
    extensions: ['html', 'htm', 'shtml'],
  },
  'text/jade': {
    extensions: ['jade'],
  },
  'text/javascript': {
    extensions: ['js', 'mjs'],
  },
  'text/jsx': {
    extensions: ['jsx'],
  },
  'text/less': {
    extensions: ['less'],
  },
  'text/markdown': {
    extensions: ['md', 'markdown'],
  },
  'text/mathml': {
    extensions: ['mml'],
  },
  'text/mdx': {
    extensions: ['mdx'],
  },
  'text/n3': {
    extensions: ['n3'],
  },
  'text/plain': {
    extensions: ['txt', 'text', 'conf', 'def', 'list', 'log', 'in', 'ini'],
  },
  'text/prs.lines.tag': {
    extensions: ['dsc'],
  },
  'text/richtext': {
    extensions: ['rtx'],
  },
  'text/rtf': {
    extensions: ['rtf'],
  },
  'text/sgml': {
    extensions: ['sgml', 'sgm'],
  },
  'text/shex': {
    extensions: ['shex'],
  },
  'text/slim': {
    extensions: ['slim', 'slm'],
  },
  'text/spdx': {
    extensions: ['spdx'],
  },
  'text/stylus': {
    extensions: ['stylus', 'styl'],
  },
  'text/tab-separated-values': {
    extensions: ['tsv'],
  },
  'text/troff': {
    extensions: ['t', 'tr', 'roff', 'man', 'me', 'ms'],
  },
  'text/turtle': {
    extensions: ['ttl'],
  },
  'text/uri-list': {
    extensions: ['uri', 'uris', 'urls'],
  },
  'text/vcard': {
    extensions: ['vcard'],
  },
  'text/vnd.curl': {
    extensions: ['curl'],
  },
  'text/vnd.curl.dcurl': {
    extensions: ['dcurl'],
  },
  'text/vnd.curl.mcurl': {
    extensions: ['mcurl'],
  },
  'text/vnd.curl.scurl': {
    extensions: ['scurl'],
  },
  'text/vnd.dvb.subtitle': {
    extensions: ['sub'],
  },
  'text/vnd.familysearch.gedcom': {
    extensions: ['ged'],
  },
  'text/vnd.fly': {
    extensions: ['fly'],
  },
  'text/vnd.fmi.flexstor': {
    extensions: ['flx'],
  },
  'text/vnd.graphviz': {
    extensions: ['gv'],
  },
  'text/vnd.in3d.3dml': {
    extensions: ['3dml'],
  },
  'text/vnd.in3d.spot': {
    extensions: ['spot'],
  },
  'text/vnd.sun.j2me.app-descriptor': {
    extensions: ['jad'],
  },
  'text/vnd.wap.wml': {
    extensions: ['wml'],
  },
  'text/vnd.wap.wmlscript': {
    extensions: ['wmls'],
  },
  'text/vtt': {
    extensions: ['vtt'],
  },
  'text/wgsl': {
    extensions: ['wgsl'],
  },
  'text/x-asm': {
    extensions: ['s', 'asm'],
  },
  'text/x-c': {
    extensions: ['c', 'cc', 'cxx', 'cpp', 'h', 'hh', 'dic'],
  },
  'text/x-component': {
    extensions: ['htc'],
  },
  'text/x-fortran': {
    extensions: ['f', 'for', 'f77', 'f90'],
  },
  'text/x-handlebars-template': {
    extensions: ['hbs'],
  },
  'text/x-java-source': {
    extensions: ['java'],
  },
  'text/x-lua': {
    extensions: ['lua'],
  },
  'text/x-markdown': {
    extensions: ['mkd'],
  },
  'text/x-nfo': {
    extensions: ['nfo'],
  },
  'text/x-opml': {
    extensions: ['opml'],
  },
  'text/x-org': {
    extensions: ['org'],
  },
  'text/x-pascal': {
    extensions: ['p', 'pas'],
  },
  'text/x-php': {
    extensions: ['php'],
  },
  'text/x-processing': {
    extensions: ['pde'],
  },
  'text/x-sass': {
    extensions: ['sass'],
  },
  'text/x-scss': {
    extensions: ['scss'],
  },
  'text/x-setext': {
    extensions: ['etx'],
  },
  'text/x-sfv': {
    extensions: ['sfv'],
  },
  'text/x-suse-ymp': {
    extensions: ['ymp'],
  },
  'text/x-uuencode': {
    extensions: ['uu'],
  },
  'text/x-vcalendar': {
    extensions: ['vcs'],
  },
  'text/x-vcard': {
    extensions: ['vcf'],
  },
  'text/xml': {
    extensions: ['xml'],
  },
  'text/yaml': {
    extensions: ['yaml', 'yml'],
  },
  'video/3gpp': {
    extensions: ['3gp', '3gpp'],
  },
  'video/3gpp2': {
    extensions: ['3g2'],
  },
  'video/h261': {
    extensions: ['h261'],
  },
  'video/h263': {
    extensions: ['h263'],
  },
  'video/h264': {
    extensions: ['h264'],
  },
  'video/iso.segment': {
    extensions: ['m4s'],
  },
  'video/jpeg': {
    extensions: ['jpgv'],
  },
  'video/jpm': {
    extensions: ['jpm', 'jpgm'],
  },
  'video/matroska': {
    extensions: ['mkv'],
  },
  'video/matroska-3d': {
    extensions: ['mk3d'],
  },
  'video/mj2': {
    extensions: ['mj2', 'mjp2'],
  },
  'video/mp2t': {
    extensions: ['ts', 'm2t', 'm2ts', 'mts'],
  },
  'video/mp4': {
    extensions: ['mp4', 'mp4v', 'mpg4'],
  },
  'video/mpeg': {
    extensions: ['mpeg', 'mpg', 'mpe', 'm1v', 'm2v'],
  },
  'video/ogg': {
    extensions: ['ogv'],
  },
  'video/quicktime': {
    extensions: ['qt', 'mov'],
  },
  'video/vnd.dece.hd': {
    extensions: ['uvh', 'uvvh'],
  },
  'video/vnd.dece.mobile': {
    extensions: ['uvm', 'uvvm'],
  },
  'video/vnd.dece.pd': {
    extensions: ['uvp', 'uvvp'],
  },
  'video/vnd.dece.sd': {
    extensions: ['uvs', 'uvvs'],
  },
  'video/vnd.dece.video': {
    extensions: ['uvv', 'uvvv'],
  },
  'video/vnd.dvb.file': {
    extensions: ['dvb'],
  },
  'video/vnd.fvt': {
    extensions: ['fvt'],
  },
  'video/vnd.mpegurl': {
    extensions: ['mxu', 'm4u'],
  },
  'video/vnd.ms-playready.media.pyv': {
    extensions: ['pyv'],
  },
  'video/vnd.uvvu.mp4': {
    extensions: ['uvu', 'uvvu'],
  },
  'video/vnd.vivo': {
    extensions: ['viv'],
  },
  'video/webm': {
    extensions: ['webm'],
  },
  'video/x-f4v': {
    extensions: ['f4v'],
  },
  'video/x-fli': {
    extensions: ['fli'],
  },
  'video/x-flv': {
    extensions: ['flv'],
  },
  'video/x-m4v': {
    extensions: ['m4v'],
  },
  'video/x-matroska': {
    extensions: ['mkv', 'mk3d', 'mks'],
  },
  'video/x-mng': {
    extensions: ['mng'],
  },
  'video/x-ms-asf': {
    extensions: ['asf', 'asx'],
  },
  'video/x-ms-vob': {
    extensions: ['vob'],
  },
  'video/x-ms-wm': {
    extensions: ['wm'],
  },
  'video/x-ms-wmv': {
    extensions: ['wmv'],
  },
  'video/x-ms-wmx': {
    extensions: ['wmx'],
  },
  'video/x-ms-wvx': {
    extensions: ['wvx'],
  },
  'video/x-msvideo': {
    extensions: ['avi'],
  },
  'video/x-sgi-movie': {
    extensions: ['movie'],
  },
  'video/x-smv': {
    extensions: ['smv'],
  },
  'x-conference/x-cooltalk': {
    extensions: ['ice'],
  },
};

export default mimeTypeObj;
